module.exports = __webpack_public_path__ + "img/in-work2.b5f89f23.jpg";